export default __webpack_public_path__ + "static/template-7f4a05bf9485e69843c63a1e9bed71ba.png";